import React, { Suspense, useCallback, useMemo } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import DashboardSidebar from './DashboardSidebar'
import { getAdminSidebarActiveNavId, navigateFromAdminSidebarItem } from '../lib/mainShellNav'
import { useAuth } from '../lib/AuthContext'
import { canAccessAnyAdminArea, getFirstAccessibleAdminPath } from '../lib/dashboardNav'
import AdminRouteFallback from './shared/AdminRouteFallback'
import './shared/admin.css'

export default function AdminShell() {
  const navigate = useNavigate()
  const location = useLocation()
  const { canAccessPage } = useAuth()

  const activeItemId = useMemo(
    () => getAdminSidebarActiveNavId(location.pathname, location.search),
    [location.pathname, location.search]
  )

  const showAdminPanelMenuItem = useMemo(() => canAccessAnyAdminArea(canAccessPage), [canAccessPage])

  const handleSidebarNav = useCallback(
    (id) => {
      navigateFromAdminSidebarItem(id, navigate)
    },
    [navigate]
  )

  const handleAdminPanel = useCallback(() => {
    const path = getFirstAccessibleAdminPath(canAccessPage)
    if (path) navigate(path)
  }, [canAccessPage, navigate])

  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: 'var(--color-bg-body)',
        fontFamily: "'Inter', -apple-system, sans-serif",
      }}
    >
      <DashboardSidebar
        variant="admin"
        activeItemId={activeItemId}
        onItemClick={handleSidebarNav}
        showQuickAddFooter={false}
        quickAddFooter={null}
        showAdminPanelMenuItem={showAdminPanelMenuItem}
        onAdminPanel={handleAdminPanel}
      />
      <div
        className="admin-shell-content"
        style={{
          marginLeft: 'var(--sidebar-width)',
          flex: 1,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          transition: 'margin-left 0.2s ease',
        }}
      >
        <Suspense fallback={<AdminRouteFallback />}>
          <Outlet />
        </Suspense>
      </div>
    </div>
  )
}
